import { createErrorStore } from "../../../error";
import type { TFieldKey } from "@./suf-store";
import type { DirectSalesFlowSlug } from "../constants";

/**
 * Zustand store for tracking validation errors and validated fields
 * for the direct sales sign-up flow.
 */
export const useDirectSalesFlowErrorStore = createErrorStore<TFieldKey, DirectSalesFlowSlug>(
  "direct-sales-suf-error-store",
);
